import { render, staticRenderFns } from "./NoticeDialogCenter.vue?vue&type=template&id=671c76f0&scoped=true&"
import script from "./NoticeDialogCenter.vue?vue&type=script&lang=ts&"
export * from "./NoticeDialogCenter.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeDialogCenter.vue?vue&type=style&index=0&id=671c76f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c76f0",
  null
  
)

export default component.exports